export default __webpack_public_path__ + "static/pp-bonapp-ee1c02fbad02f5c12b7630ee9639999b.jpg";